module.exports = __webpack_public_path__ + "img/screw-undefined.7e1ee32d.png";